/**
 * Auth Callback Page
 * 
 * Handles the OAuth callback from Twitch. Extracts the JWT token
 * from the URL fragment and redirects to the dashboard.
 */

import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { handleAuthCallback } from '@/hooks/useAuth'

export default function AuthCallback() {
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)
  
  useEffect(() => {
    // Try to extract and store the token
    const success = handleAuthCallback()
    
    if (success) {
      // Token stored successfully, redirect to dashboard
      // Use a small delay to ensure state updates
      setTimeout(() => {
        navigate('/', { replace: true })
        // Force a page reload to ensure auth state is fresh
        window.location.reload()
      }, 100)
    } else {
      setError('Authentication failed. Please try again.')
    }
  }, [navigate])
  
  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface-app p-4">
        <div className="card max-w-md w-full text-center">
          <div className="text-state-danger mb-4">
            <svg
              className="w-16 h-16 mx-auto"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <h2 className="text-xl font-semibold text-text-primary mb-2">
            Authentication Failed
          </h2>
          <p className="text-text-secondary mb-6">{error}</p>
          <a href="/login" className="btn-primary">
            Back to Login
          </a>
        </div>
      </div>
    )
  }
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-app">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-synth-magenta mx-auto mb-4"></div>
        <p className="text-text-secondary">Completing sign in...</p>
      </div>
    </div>
  )
}
